import { ManagerType } from "@/router/constants";
import { useUserStoreWithOut } from "@/store/modules/user";
import { Directive, DirectiveBinding } from "vue";

function isVisible(managerType: ManagerType) {
  const userStore = useUserStoreWithOut();
  if (userStore.isRoot) return;

  if (userStore.isProjectAdmin && managerType >= ManagerType.ProjectAdmin) {
    return true;
  }
  if (
    userStore.isOrganizationAdmin &&
    managerType >= ManagerType.OrganizationAdmin
  ) {
    return true;
  }
  if (
    userStore.isOrganizationReviewer &&
    managerType >= ManagerType.OrganizationReviewer
  ) {
    return true;
  }
  return false;
}

const setVisible = function (el: HTMLDivElement, binding: DirectiveBinding) {
  const managerType = binding.value as ManagerType;
  if (!managerType) return;

  if (!isVisible(managerType)) {
    el.parentNode?.removeChild(el);
  }
};

export const manager: Directive = {
  mounted(el: HTMLDivElement, binding: DirectiveBinding) {
    setVisible(el, binding);
  },
  updated(el: HTMLDivElement, binding: DirectiveBinding) {
    setVisible(el, binding);
  },
};
